import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Anchor, ArrowLeft, Shield } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('admin_token', res.data.token);
      toast.success('Admin login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 w-full backdrop-blur-lg bg-background/80 border-b border-border/40 h-16 flex items-center px-4 justify-between">
        <Button
          variant="ghost"
          size="sm"
          className="rounded-full"
          onClick={() => navigate('/')}
          data-testid="back-button"
        >
          <ArrowLeft className="w-4 h-4 mr-1" />
          Back
        </Button>
        <div className="flex items-center gap-2">
          <Anchor className="w-5 h-5 text-primary" />
          <span className="font-heading font-bold" data-testid="header-app-name">MarineKnow</span>
        </div>
      </header>

      <div className="max-w-md mx-auto w-full p-4 pt-12">
        <div className="bg-card border border-white/5 rounded-xl p-6" data-testid="admin-login-form">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center">
              <Shield className="w-8 h-8 text-primary" data-testid="admin-icon" />
            </div>
          </div>
          <h1 className="text-2xl font-heading font-bold text-center mb-6" data-testid="admin-login-title">
            Admin Login
          </h1>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="username" data-testid="username-label">Username</Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="mt-1"
                required
                data-testid="username-input"
              />
            </div>

            <div>
              <Label htmlFor="password" data-testid="password-label">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                className="mt-1"
                required
                data-testid="password-input"
              />
            </div>

            <Button type="submit" className="w-full rounded-full" data-testid="login-button">
              Login
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
